'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import ServiceCategoryCard from '@/app/ai-service-categories-hub/components/ServiceCategoryCard';





interface ServiceItem {
  id: string;
  name: string;
  description: string;
  image: string;
  alt: string;
  price: string;
  license: string;
  verified: boolean;
  features: string[];
}

interface ServiceCategory {
  id: string;
  name: string;
  icon: string;
  description: string;
  services: ServiceItem[];
}

const AIServiceCategoriesInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<string>('all');
  const [searchQuery, setSearchQuery] = useState('');
  const router = useRouter();

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const categories: ServiceCategory[] = [
  {
    id: 'ai-tool-subscriptions',
    name: 'AI Tool Subscriptions',
    icon: 'CpuChipIcon',
    description: 'Premium dashboard access and AI tool subscriptions with advanced features',
    services: [
    {
      id: 'ats1',
      name: 'AI Dashboard Premium',
      description: 'Full access to AI analytics dashboard with real-time insights, custom reports, and priority support',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11ec04093-1764666206470.png",
      alt: 'Modern AI analytics dashboard with real-time data visualization and performance metrics',
      price: '49.99 BNB/month',
      license: 'AITOOL-DASH-2026-EU-8847',
      verified: true,
      features: ['Real-time Analytics', 'Custom Reports', 'API Access', 'Priority Support']
    },
    {
      id: 'ats2',
      name: 'AI Content Suite Pro',
      description: 'Premium AI content generation tools for text, images, and video with unlimited usage',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc66671c-1767477219576.png",
      alt: 'AI content creation interface showing text generation and image synthesis tools',
      price: '79.99 BNB/month',
      license: 'AITOOL-CONT-2026-EU-9234',
      verified: true,
      features: ['Unlimited Generation', 'Multi-format Export', 'Commercial License', '24/7 Access']
    },
    {
      id: 'ats3',
      name: 'AI Automation Hub',
      description: 'Advanced automation workflows with AI-powered decision making and integrations',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15b31a51c-1769248701212.png",
      alt: 'Automation workflow builder with AI nodes and integration connectors',
      price: '99.99 BNB/month',
      license: 'AITOOL-AUTO-2026-EU-7621',
      verified: true,
      features: ['Workflow Builder', 'AI Decision Engine', '100+ Integrations', 'Team Collaboration']
    }]

  },
  {
    id: 'digital-membership',
    name: 'Digital Membership Systems',
    icon: 'UserGroupIcon',
    description: 'Exclusive closed-area access with premium content and community features',
    services: [
    {
      id: 'dms1',
      name: 'Elite Members Portal',
      description: 'Exclusive access to premium resources, training materials, and expert consultations',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19e6e26be-1768240087265.png",
      alt: 'Professional members portal interface with exclusive content sections and user profiles',
      price: '149.99 BNB/year',
      license: 'MEMBER-ELITE-2026-EU-4512',
      verified: true,
      features: ['Exclusive Content', 'Expert Access', 'Private Forums', 'Monthly Webinars']
    },
    {
      id: 'dms2',
      name: 'VIP Learning Academy',
      description: 'Comprehensive learning platform with courses, certifications, and mentorship programs',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_146254e45-1764672099813.png",
      alt: 'Online learning platform showing course catalog and certification programs',
      price: '199.99 BNB/year',
      license: 'MEMBER-LEARN-2026-EU-8823',
      verified: true,
      features: ['50+ Courses', 'Certifications', '1-on-1 Mentorship', 'Lifetime Updates']
    },
    {
      id: 'dms3',
      name: 'Professional Network Hub',
      description: 'Private networking platform connecting industry professionals with collaboration tools',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c2de343d-1768654522838.png",
      alt: 'Professional networking interface with member profiles and collaboration features',
      price: '89.99 BNB/month',
      license: 'MEMBER-NET-2026-EU-3347',
      verified: true,
      features: ['Verified Professionals', 'Direct Messaging', 'Project Collaboration', 'Event Access']
    }]

  },
  {
    id: 'telegram-bots',
    name: 'Telegram Bots',
    icon: 'ChatBubbleLeftEllipsisIcon',
    description: 'Advanced Telegram automation bots for community management and engagement',
    services: [
    {
      id: 'tgb1',
      name: 'TeleGuard Pro Bot',
      description: 'Advanced moderation bot with AI-powered spam detection and user verification',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_12f5fe13a-1764644024710.png",
      alt: 'Telegram bot interface showing moderation controls and spam detection features',
      price: '29.99 BNB/month',
      license: 'TGBOT-GUARD-2026-EU-5621',
      verified: true,
      features: ['AI Spam Filter', 'Auto Moderation', 'User Verification', 'Custom Rules']
    },
    {
      id: 'tgb2',
      name: 'TeleEngage Bot',
      description: 'Engagement bot with polls, quizzes, and automated content distribution',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bd09cd1a-1769248702888.png",
      alt: 'Telegram engagement bot showing interactive polls and quiz features',
      price: '39.99 BNB/month',
      license: 'TGBOT-ENGAGE-2026-EU-7834',
      verified: true,
      features: ['Interactive Polls', 'Quiz Builder', 'Content Scheduler', 'Analytics Dashboard']
    },
    {
      id: 'tgb3',
      name: 'TeleCommerce Bot',
      description: 'E-commerce bot for product catalogs, orders, and payment processing via Telegram',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19442b93b-1769955827850.png",
      alt: 'Telegram commerce bot interface with product catalog and payment processing',
      price: '59.99 BNB/month',
      license: 'TGBOT-COMM-2026-EU-9123',
      verified: true,
      features: ['Product Catalog', 'Order Management', 'Crypto Payments', 'Inventory Tracking']
    }]

  },
  {
    id: 'discord-bots',
    name: 'Discord Bots',
    icon: 'CommandLineIcon',
    description: 'Powerful Discord bots for server management and community engagement',
    services: [
    {
      id: 'dcb1',
      name: 'DiscordGuardian Bot',
      description: 'Comprehensive server protection with anti-raid, verification, and logging systems',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_12f5fe13a-1764644024710.png",
      alt: 'Discord bot dashboard showing server protection and moderation features',
      price: '34.99 BNB/month',
      license: 'DCBOT-GUARD-2026-EU-4456',
      verified: true,
      features: ['Anti-Raid Protection', 'Verification System', 'Audit Logs', 'Role Management']
    },
    {
      id: 'dcb2',
      name: 'DiscordMusic Pro',
      description: 'High-quality music bot with playlist management and audio effects',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_12f5fe13a-1764644024710.png",
      alt: 'Discord music bot interface with playlist controls and audio visualization',
      price: '24.99 BNB/month',
      license: 'DCBOT-MUSIC-2026-EU-6789',
      verified: true,
      features: ['HD Audio Quality', 'Playlist Management', 'Audio Effects', 'Multi-server Support']
    },
    {
      id: 'dcb3',
      name: 'DiscordEconomy Bot',
      description: 'Virtual economy system with currency, shops, and mini-games for your server',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1523f9cca-1769178400375.png",
      alt: 'Discord economy bot showing virtual currency system and shop interface',
      price: '44.99 BNB/month',
      license: 'DCBOT-ECON-2026-EU-8912',
      verified: true,
      features: ['Virtual Currency', 'Custom Shops', 'Mini-games', 'Leaderboards']
    }]

  },
  {
    id: 'trading-helpers',
    name: 'Trading Helper Bots',
    icon: 'ChartBarIcon',
    description: 'Non-signal trading assistants for market analysis and portfolio tracking',
    services: [
    {
      id: 'thb1',
      name: 'CryptoTracker Pro',
      description: 'Real-time portfolio tracking with price alerts and performance analytics',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_125ce92bb-1767025087661.png",
      alt: 'Crypto portfolio tracker showing real-time prices and performance charts',
      price: '19.99 BNB/month',
      license: 'TRADE-TRACK-2026-EU-3345',
      verified: true,
      features: ['Multi-exchange Support', 'Price Alerts', 'Performance Analytics', 'Tax Reports']
    },
    {
      id: 'thb2',
      name: 'MarketAnalyzer AI',
      description: 'AI-powered market analysis with sentiment tracking and trend detection',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_146743959-1766298170468.png",
      alt: 'Market analysis dashboard with AI sentiment indicators and trend charts',
      price: '49.99 BNB/month',
      license: 'TRADE-ANALYZE-2026-EU-7723',
      verified: true,
      features: ['Sentiment Analysis', 'Trend Detection', 'News Aggregation', 'Custom Indicators']
    },
    {
      id: 'thb3',
      name: 'RiskManager Bot',
      description: 'Portfolio risk assessment and position sizing calculator for crypto traders',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f434844-1766495160949.png",
      alt: 'Risk management interface showing portfolio allocation and risk metrics',
      price: '39.99 BNB/month',
      license: 'TRADE-RISK-2026-EU-5567',
      verified: true,
      features: ['Risk Assessment', 'Position Sizing', 'Stop Loss Calculator', 'Diversification Tools']
    }]

  },
  {
    id: 'automation-bots',
    name: 'Automation Bots',
    icon: 'BoltIcon',
    description: 'Scraper, lead generation, and posting automation bots',
    services: [
    {
      id: 'aub1',
      name: 'WebScraper Pro',
      description: 'Advanced web scraping bot with data extraction and export capabilities',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_17318c960-1766474568281.png",
      alt: 'Web scraping interface showing data extraction and export options',
      price: '69.99 BNB/month',
      license: 'AUTO-SCRAPE-2026-EU-8834',
      verified: true,
      features: ['Visual Scraper', 'API Integration', 'Data Cleaning', 'Scheduled Scraping']
    },
    {
      id: 'aub2',
      name: 'LeadGen Master',
      description: 'Automated lead generation from social media and business directories',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1725306e4-1764865313096.png",
      alt: 'Lead generation dashboard with contact information and filtering options',
      price: '89.99 BNB/month',
      license: 'AUTO-LEAD-2026-EU-4421',
      verified: true,
      features: ['Multi-platform Search', 'Email Finder', 'Lead Verification', 'CRM Export']
    },
    {
      id: 'aub3',
      name: 'SocialPoster AI',
      description: 'Automated social media posting across multiple platforms with AI content optimization',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128cd20f9-1766924917789.png",
      alt: 'Social media automation dashboard with post scheduler and analytics',
      price: '54.99 BNB/month',
      license: 'AUTO-POST-2026-EU-6678',
      verified: true,
      features: ['Multi-platform Posting', 'Content Calendar', 'AI Optimization', 'Analytics']
    }]

  },
  {
    id: 'ai-services',
    name: 'AI-Based Services',
    icon: 'SparklesIcon',
    description: 'AI services for logo design, landing pages, CV creation, and script writing',
    services: [
    {
      id: 'ais1',
      name: 'LogoForge AI',
      description: 'AI-powered logo design with unlimited revisions and brand kit generation',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19dca9f75-1769248703039.png",
      alt: 'AI logo design interface showing multiple logo variations and brand colors',
      price: '29.99 BNB/design',
      license: 'AISERVICE-LOGO-2026-EU-9945',
      verified: true,
      features: ['Unlimited Revisions', 'Brand Kit', 'Vector Files', 'Commercial License']
    },
    {
      id: 'ais2',
      name: 'LandingPage AI Builder',
      description: 'Create high-converting landing pages with AI in minutes, no coding required',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fdbcf80b-1768027993033.png",
      alt: 'Landing page builder interface with drag-and-drop elements and templates',
      price: '49.99 BNB/page',
      license: 'AISERVICE-LAND-2026-EU-7712',
      verified: true,
      features: ['AI Content Generation', 'Mobile Responsive', 'SEO Optimized', 'Analytics Integration']
    },
    {
      id: 'ais3',
      name: 'CV Master AI',
      description: 'Professional CV and resume creation with ATS optimization and industry templates',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_126dfea82-1769415182683.png",
      alt: 'Professional CV builder showing resume templates and formatting options',
      price: '19.99 BNB/CV',
      license: 'AISERVICE-CV-2026-EU-3389',
      verified: true,
      features: ['ATS Optimized', '50+ Templates', 'Cover Letter', 'LinkedIn Profile']
    },
    {
      id: 'ais4',
      name: 'ScriptWriter AI',
      description: 'AI script writing for videos, podcasts, and presentations with tone customization',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6d7e10c-1768220361868.png",
      alt: 'Script writing interface with AI suggestions and formatting tools',
      price: '39.99 BNB/script',
      license: 'AISERVICE-SCRIPT-2026-EU-5523',
      verified: true,
      features: ['Multiple Formats', 'Tone Customization', 'Collaboration Tools', 'Export Options']
    }]

  },
  {
    id: 'prompt-packages',
    name: 'Prompt Packages',
    icon: 'DocumentTextIcon',
    description: 'Niche-focused prompt collections for various AI applications',
    services: [
    {
      id: 'prp1',
      name: 'Marketing Prompts Pro',
      description: '500+ proven prompts for marketing, copywriting, and social media content',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11994e212-1764678466539.png",
      alt: 'Marketing prompt library showing categorized prompts and examples',
      price: '24.99 BNB/package',
      license: 'PROMPT-MARKET-2026-EU-8856',
      verified: true,
      features: ['500+ Prompts', 'Regular Updates', 'Use Cases', 'Community Access']
    },
    {
      id: 'prp2',
      name: 'Developer Prompts Suite',
      description: 'Comprehensive prompt collection for code generation, debugging, and documentation',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11994e212-1764678466539.png",
      alt: 'Developer prompt interface with code examples and documentation',
      price: '34.99 BNB/package',
      license: 'PROMPT-DEV-2026-EU-4423',
      verified: true,
      features: ['300+ Code Prompts', 'Multi-language', 'Best Practices', 'Templates']
    },
    {
      id: 'prp3',
      name: 'Creative Writing Prompts',
      description: 'Curated prompts for storytelling, fiction, and creative content generation',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11f0e42e1-1764678467007.png",
      alt: 'Creative writing prompt collection with story templates and examples',
      price: '19.99 BNB/package',
      license: 'PROMPT-CREATIVE-2026-EU-6634',
      verified: true,
      features: ['400+ Prompts', 'Genre Specific', 'Character Builder', 'Plot Templates']
    }]

  },
  {
    id: 'fast-delivery',
    name: '24-Hour Digital Services',
    icon: 'ClockIcon',
    description: 'Express digital services delivered within 24 hours',
    services: [
    {
      id: 'fds1',
      name: 'Express Logo Design',
      description: 'Professional logo design delivered in 24 hours with 3 concepts and revisions',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_175a50af0-1769248702790.png",
      alt: 'Fast logo design service showing multiple logo concepts and quick turnaround',
      price: '79.99 BNB',
      license: 'FAST-LOGO-2026-EU-9912',
      verified: true,
      features: ['24h Delivery', '3 Concepts', '2 Revisions', 'Source Files']
    },
    {
      id: 'fds2',
      name: 'Rapid Website Setup',
      description: 'Complete website setup with hosting, domain, and basic content in 24 hours',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1741eac46-1766466755433.png",
      alt: 'Website setup service showing hosting configuration and domain setup',
      price: '149.99 BNB',
      license: 'FAST-WEB-2026-EU-7745',
      verified: true,
      features: ['24h Launch', 'Hosting Setup', 'Domain Config', 'SSL Certificate']
    },
    {
      id: 'fds3',
      name: 'Express Content Writing',
      description: 'Professional content writing for blogs, articles, and web pages in 24 hours',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19cdb939c-1769955826785.png",
      alt: 'Content writing service showing article creation and editing process',
      price: '59.99 BNB',
      license: 'FAST-CONTENT-2026-EU-3367',
      verified: true,
      features: ['24h Delivery', 'SEO Optimized', '1000+ Words', 'Unlimited Revisions']
    }]

  },
  {
    id: 'telegram-communities',
    name: 'Closed Telegram Communities',
    icon: 'LockClosedIcon',
    description: 'Exclusive Telegram groups with premium content and networking',
    services: [
    {
      id: 'tgc1',
      name: 'Crypto Traders Elite',
      description: 'Private Telegram group for serious crypto traders with daily market analysis',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_12a594528-1769427044436.png",
      alt: 'Exclusive crypto trading community with market analysis and member discussions',
      price: '99.99 BNB/month',
      license: 'TGCOMM-CRYPTO-2026-EU-8823',
      verified: true,
      features: ['Daily Analysis', 'Expert Insights', 'Private Channels', 'Member Networking']
    },
    {
      id: 'tgc2',
      name: 'AI Entrepreneurs Hub',
      description: 'Exclusive community for AI business owners and entrepreneurs',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1dd5d5e31-1769955829333.png",
      alt: 'AI entrepreneur community showing business discussions and collaboration',
      price: '149.99 BNB/month',
      license: 'TGCOMM-AI-2026-EU-5534',
      verified: true,
      features: ['Business Resources', 'Collaboration Opportunities', 'Expert AMAs', 'Deal Flow']
    },
    {
      id: 'tgc3',
      name: 'Growth Hackers Circle',
      description: 'Private group for growth marketers sharing strategies and case studies',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15b087382-1769248702358.png",
      alt: 'Growth hacking community with marketing strategies and case studies',
      price: '79.99 BNB/month',
      license: 'TGCOMM-GROWTH-2026-EU-4456',
      verified: true,
      features: ['Strategy Sharing', 'Case Studies', 'Tool Recommendations', 'Weekly Challenges']
    }]

  },
  {
    id: 'discord-communities',
    name: 'Closed Discord Communities',
    icon: 'ShieldCheckIcon',
    description: 'Private Discord servers with exclusive content and member benefits',
    services: [
    {
      id: 'dcc1',
      name: 'NFT Collectors Guild',
      description: 'Exclusive Discord for NFT collectors with alpha calls and whitelist access',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1938fb66e-1769427043948.png",
      alt: 'NFT collector community with exclusive drops and whitelist opportunities',
      price: '199.99 BNB/month',
      license: 'DCCOMM-NFT-2026-EU-9978',
      verified: true,
      features: ['Alpha Calls', 'Whitelist Access', 'Expert Analysis', 'Private Sales']
    },
    {
      id: 'dcc2',
      name: 'Web3 Developers Network',
      description: 'Private Discord for Web3 developers with code reviews and job opportunities',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1086882f5-1765985693234.png",
      alt: 'Web3 developer community with code collaboration and job board',
      price: '89.99 BNB/month',
      license: 'DCCOMM-WEB3-2026-EU-6612',
      verified: true,
      features: ['Code Reviews', 'Job Board', 'Learning Resources', 'Hackathons']
    },
    {
      id: 'dcc3',
      name: 'Digital Nomads Elite',
      description: 'Exclusive community for location-independent professionals and entrepreneurs',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_134b459ce-1769427041839.png",
      alt: 'Digital nomad community with travel tips and remote work opportunities',
      price: '69.99 BNB/month',
      license: 'DCCOMM-NOMAD-2026-EU-3345',
      verified: true,
      features: ['Travel Tips', 'Coworking Deals', 'Visa Guidance', 'Meetups']
    }]

  },
  {
    id: 'leak-content',
    name: 'AI Tool Lists & Leak Content',
    icon: 'ListBulletIcon',
    description: 'Curated AI tool directories and exclusive leaked resources',
    services: [
    {
      id: 'lkc1',
      name: 'AI Tools Master List',
      description: 'Comprehensive directory of 1000+ AI tools with reviews and comparisons',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16dbd83f4-1768382927583.png",
      alt: 'Comprehensive AI tools directory with categories and detailed reviews',
      price: '29.99 BNB/year',
      license: 'LEAK-TOOLS-2026-EU-7789',
      verified: true,
      features: ['1000+ Tools', 'Regular Updates', 'Comparison Charts', 'Discount Codes']
    },
    {
      id: 'lkc2',
      name: 'Premium Prompts Vault',
      description: 'Exclusive collection of leaked premium prompts from top AI creators',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10420cb32-1768590141576.png",
      alt: 'Premium prompt collection with exclusive AI prompts and templates',
      price: '49.99 BNB/package',
      license: 'LEAK-PROMPT-2026-EU-4423',
      verified: true,
      features: ['5000+ Prompts', 'Multi-platform', 'Tested Results', 'Monthly Additions']
    },
    {
      id: 'lkc3',
      name: 'Course Materials Archive',
      description: 'Curated collection of premium course materials and learning resources',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1348cbbf8-1769427043984.png",
      alt: 'Course materials archive with learning resources and tutorials',
      price: '79.99 BNB/year',
      license: 'LEAK-COURSE-2026-EU-8856',
      verified: true,
      features: ['100+ Courses', 'Video Content', 'Templates', 'Lifetime Access']
    }]

  },
  {
    id: 'growth-hack',
    name: 'Growth Hack Content',
    icon: 'RocketLaunchIcon',
    description: 'Proven growth hacking strategies and implementation guides',
    services: [
    {
      id: 'ghc1',
      name: 'Viral Marketing Playbook',
      description: 'Complete guide to viral marketing with case studies and templates',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15b087382-1769248702358.png",
      alt: 'Viral marketing playbook with growth strategies and case studies',
      price: '149.99 BNB',
      license: 'GROWTH-VIRAL-2026-EU-9934',
      verified: true,
      features: ['50+ Strategies', 'Case Studies', 'Templates', 'Video Tutorials']
    },
    {
      id: 'ghc2',
      name: 'SEO Domination Guide',
      description: 'Advanced SEO strategies for ranking #1 on Google with proven tactics',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bd32a326-1767223739617.png",
      alt: 'SEO guide showing ranking strategies and optimization techniques',
      price: '99.99 BNB',
      license: 'GROWTH-SEO-2026-EU-6667',
      verified: true,
      features: ['Advanced Tactics', 'Tool Recommendations', 'Audit Checklist', 'Updates']
    },
    {
      id: 'ghc3',
      name: 'Social Media Growth Kit',
      description: 'Complete toolkit for growing social media following organically',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ab85d0d2-1766930067882.png",
      alt: 'Social media growth toolkit with content templates and scheduling guides',
      price: '79.99 BNB',
      license: 'GROWTH-SOCIAL-2026-EU-3312',
      verified: true,
      features: ['Content Templates', 'Scheduling Guide', 'Engagement Tactics', 'Analytics']
    }]

  },
  {
    id: 'white-label',
    name: 'White-Label AI SaaS',
    icon: 'BuildingStorefrontIcon',
    description: 'Rebrandable AI SaaS solutions for resale',
    services: [
    {
      id: 'wls1',
      name: 'AI Chatbot Platform',
      description: 'White-label AI chatbot platform ready to rebrand and resell to clients',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a9e98960-1769955828367.png",
      alt: 'White-label chatbot platform with customization and branding options',
      price: '499.99 BNB/month',
      license: 'WHITE-CHAT-2026-EU-8845',
      verified: true,
      features: ['Full Rebranding', 'Client Management', 'API Access', 'Support Included']
    },
    {
      id: 'wls2',
      name: 'AI Content Generator SaaS',
      description: 'Complete white-label content generation platform with admin dashboard',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d13deda1-1767467465192.png",
      alt: 'White-label content generator with admin dashboard and user management',
      price: '699.99 BNB/month',
      license: 'WHITE-CONTENT-2026-EU-5523',
      verified: true,
      features: ['Admin Dashboard', 'User Management', 'Payment Integration', 'Documentation']
    },
    {
      id: 'wls3',
      name: 'AI Image Studio SaaS',
      description: 'White-label AI image generation platform with custom branding',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d13deda1-1767467465192.png",
      alt: 'White-label image generation platform with branding customization',
      price: '599.99 BNB/month',
      license: 'WHITE-IMAGE-2026-EU-7712',
      verified: true,
      features: ['Custom Branding', 'Credit System', 'API Integration', 'Mobile Ready']
    }]

  },
  {
    id: 'premium-subscriptions',
    name: 'Premium Content Subscriptions',
    icon: 'StarIcon',
    description: 'Premium content subscriptions with regular updates',
    services: [
    {
      id: 'pcs1',
      name: 'AI News & Insights',
      description: 'Daily AI industry news, analysis, and insights with expert commentary',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c5aa9c97-1769955826228.png",
      alt: 'AI news subscription with daily updates and expert analysis',
      price: '49.99 BNB/month',
      license: 'PREMIUM-NEWS-2026-EU-8812',
      verified: true,
      features: ['Daily Updates', 'Expert Analysis', 'Trend Reports', 'Newsletter']
    },
    {
      id: 'pcs2',
      name: 'Trading Strategies Library',
      description: 'Premium trading strategies and market analysis updated weekly',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_12d498b73-1767642461004.png",
      alt: 'Trading strategies library with market analysis and weekly updates',
      price: '99.99 BNB/month',
      license: 'PREMIUM-TRADE-2026-EU-5545',
      verified: true,
      features: ['Weekly Strategies', 'Market Analysis', 'Backtesting Data', 'Video Tutorials']
    },
    {
      id: 'pcs3',
      name: 'Design Assets Pro',
      description: 'Premium design assets library with monthly additions and commercial license',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_14795a950-1764681674827.png",
      alt: 'Design assets library with templates, graphics, and commercial license',
      price: '39.99 BNB/month',
      license: 'PREMIUM-DESIGN-2026-EU-3367',
      verified: true,
      features: ['Monthly Additions', 'Commercial License', 'All Formats', 'Support']
    }]

  },
  {
    id: 'micro-saas',
    name: 'Micro SaaS Access',
    icon: 'CubeIcon',
    description: 'Access to specialized micro SaaS applications',
    services: [
    {
      id: 'msa1',
      name: 'Email Signature Generator',
      description: 'Professional email signature generator with analytics tracking',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a6e715f8-1766331873609.png",
      alt: 'Email signature generator with professional templates and analytics',
      price: '9.99 BNB/month',
      license: 'MICRO-EMAIL-2026-EU-9956',
      verified: true,
      features: ['50+ Templates', 'Analytics', 'Team Management', 'Export Options']
    },
    {
      id: 'msa2',
      name: 'Link Shortener Pro',
      description: 'Advanced link shortener with custom domains and detailed analytics',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_117c81e5e-1769955826961.png",
      alt: 'Link shortener interface with custom domains and analytics dashboard',
      price: '14.99 BNB/month',
      license: 'MICRO-LINK-2026-EU-7723',
      verified: true,
      features: ['Custom Domains', 'Analytics', 'QR Codes', 'API Access']
    },
    {
      id: 'msa3',
      name: 'Screenshot API',
      description: 'Automated screenshot generation API for websites and applications',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183e5fc54-1769427047192.png",
      alt: 'Screenshot API service with automated capture and customization options',
      price: '19.99 BNB/month',
      license: 'MICRO-SCREEN-2026-EU-4434',
      verified: true,
      features: ['Automated Capture', 'Custom Sizes', 'Scheduling', 'Cloud Storage']
    }]

  },
  {
    id: 'hybrid-models',
    name: 'Bot + Subscription Hybrids',
    icon: 'PuzzlePieceIcon',
    description: 'Combined bot services with subscription features',
    services: [
    {
      id: 'hyb1',
      name: 'TradingBot + Signals',
      description: 'Automated trading bot with premium signal subscription and analytics',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10d744cc7-1769955827757.png",
      alt: 'Trading bot interface with signal integration and performance analytics',
      price: '199.99 BNB/month',
      license: 'HYBRID-TRADE-2026-EU-8867',
      verified: true,
      features: ['Automated Trading', 'Premium Signals', 'Risk Management', '24/7 Support']
    },
    {
      id: 'hyb2',
      name: 'ContentBot + Library',
      description: 'AI content bot with access to premium template and prompt library',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1aed68493-1766487150090.png",
      alt: 'Content bot with template library and AI generation features',
      price: '79.99 BNB/month',
      license: 'HYBRID-CONTENT-2026-EU-5512',
      verified: true,
      features: ['AI Content Bot', 'Template Library', 'Unlimited Generation', 'Priority Queue']
    },
    {
      id: 'hyb3',
      name: 'ModBot + Community',
      description: 'Advanced moderation bot with exclusive community access and resources',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_12f5fe13a-1764644024710.png",
      alt: 'Moderation bot with community features and resource library',
      price: '59.99 BNB/month',
      license: 'HYBRID-MOD-2026-EU-3389',
      verified: true,
      features: ['Auto Moderation', 'Community Access', 'Resource Library', 'Custom Rules']
    }]

  }];


  const filterOptions = [
  { id: 'all', label: 'All Categories', icon: 'Squares2X2Icon' },
  { id: 'bots', label: 'Bots & Automation', icon: 'BoltIcon' },
  { id: 'communities', label: 'Communities', icon: 'UserGroupIcon' },
  { id: 'services', label: 'AI Services', icon: 'SparklesIcon' },
  { id: 'content', label: 'Content & Resources', icon: 'DocumentTextIcon' },
  { id: 'saas', label: 'SaaS & APIs', icon: 'CodeBracketIcon' }];


  const filteredCategories = categories.filter((category) => {
    if (selectedFilter === 'all') return true;
    if (selectedFilter === 'bots') return ['telegram-bots', 'discord-bots', 'automation-bots', 'trading-helpers'].includes(category.id);
    if (selectedFilter === 'communities') return ['telegram-communities', 'discord-communities'].includes(category.id);
    if (selectedFilter === 'services') return ['ai-services', 'ai-tool-subscriptions', 'fast-delivery'].includes(category.id);
    if (selectedFilter === 'content') return ['prompt-packages', 'leak-content', 'growth-hack', 'premium-subscriptions'].includes(category.id);
    if (selectedFilter === 'saas') return ['white-label', 'api-access', 'micro-saas', 'hybrid-models', 'digital-membership'].includes(category.id);
    return true;
  }).filter((category) => {
    if (!searchQuery) return true;
    return category.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    category.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
    category.services.some((service) =>
    service.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    service.description.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:782:6" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="782" data-component-end-line="784" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%20flex%20items-center%20justify-center%22%7D" className="min-h-screen bg-background flex items-center justify-center">
        <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:783:8" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="783" data-component-end-line="783" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-spin%20rounded-full%20h-12%20w-12%20border-t-2%20border-b-2%20border-secondary%22%7D" className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-secondary"></div>
      </div>);

  }

  return (
    <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:789:4" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="789" data-component-end-line="908" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%22%7D" className="min-h-screen bg-background">
      {/* Hero Section */}
      <section data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:791:6" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="791" data-component-end-line="807" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22relative%20py-20%20overflow-hidden%22%7D" className="relative py-20 overflow-hidden">
        <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:792:8" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="792" data-component-end-line="792" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-gradient-to-b%20from-secondary%2F5%20to-transparent%22%7D" className="absolute inset-0 bg-gradient-to-b from-secondary/5 to-transparent"></div>
        <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:793:8" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="793" data-component-end-line="806" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20relative%20z-10%22%7D" className="container mx-auto px-4 relative z-10">
          <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:794:10" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="794" data-component-end-line="805" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20max-w-4xl%20mx-auto%20space-y-6%22%7D" className="text-center max-w-4xl mx-auto space-y-6">
            <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:795:12" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="795" data-component-end-line="798" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22inline-flex%20items-center%20space-x-2%20bg-secondary%2F10%20px-4%20py-2%20rounded-full%22%7D" className="inline-flex items-center space-x-2 bg-secondary/10 px-4 py-2 rounded-full">
              <Icon data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:796:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="796" data-component-end-line="796" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22SparklesIcon%22%2C%22className%22%3A%22text-secondary%22%7D" name="SparklesIcon" size={20} className="text-secondary" />
              <span data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:797:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="797" data-component-end-line="797" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-sm%20font-semibold%20text-secondary%22%2C%22textContent%22%3A%2218%20Service%20Categories%22%7D" className="text-sm font-semibold text-secondary">18 Service Categories</span>
            </div>
            <h1 data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:799:12" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="799" data-component-end-line="801" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22text-4xl%20sm%3Atext-5xl%20lg%3Atext-6xl%20font-headline%20font-bold%20text-foreground%22%2C%22textContent%22%3A%22AI%20Service%20Categories%20Hub%22%7D" className="text-4xl sm:text-5xl lg:text-6xl font-headline font-bold text-foreground">
              AI Service Categories Hub
            </h1>
            <p data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:802:12" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="802" data-component-end-line="804" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20sm%3Atext-xl%20text-muted-foreground%20max-w-2xl%20mx-auto%22%2C%22textContent%22%3A%22Comprehensive%20marketplace%20with%20verified%20licenses%2C%20realistic%20service%20previews%2C%20and%20instant%20subscription%20access%22%7D" className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto">
              Comprehensive marketplace with verified licenses, realistic service previews, and instant subscription access
            </p>
          </div>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:810:6" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="810" data-component-end-line="852" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-8%20border-b%20border-border%22%7D" className="py-8 border-b border-border">
        <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:811:8" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="811" data-component-end-line="851" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%22%7D" className="container mx-auto px-4">
          <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:812:10" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="812" data-component-end-line="843" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20lg%3Aflex-row%20gap-4%20items-center%20justify-between%22%7D" className="flex flex-col lg:flex-row gap-4 items-center justify-between">
            {/* Search Bar */}
            <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:814:12" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="814" data-component-end-line="825" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20lg%3Aw-96%22%7D" className="w-full lg:w-96">
              <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:815:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="815" data-component-end-line="824" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
                <Icon data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:816:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="816" data-component-end-line="816" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22MagnifyingGlassIcon%22%2C%22className%22%3A%22absolute%20left-3%20top-1%2F2%20transform%20-translate-y-1%2F2%20text-muted-foreground%22%7D" name="MagnifyingGlassIcon" size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
                <input data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:817:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="817" data-component-end-line="822" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22value%22%3A%22%5Bvar%3AsearchQuery%5D%22%2C%22className%22%3A%22w-full%20pl-10%20pr-4%20py-3%20bg-card%20border%20border-border%20rounded-lg%20focus%3Aoutline-none%20focus%3Aborder-secondary%20transition-colors%22%7D"
                  type="text"
                  placeholder="Search services..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 bg-card border border-border rounded-lg focus:outline-none focus:border-secondary transition-colors" />

              </div>
            </div>

            {/* Filter Buttons */}
            <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:828:12" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="828" data-component-end-line="842" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-2%20justify-center%22%7D" className="flex flex-wrap gap-2 justify-center">
              {filterOptions.map((option) =>
              <button data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:830:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="830" data-component-end-line="840" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                key={option.id}
                onClick={() => setSelectedFilter(option.id)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-300 ${
                selectedFilter === option.id ?
                'bg-secondary text-background font-semibold' : 'bg-card text-muted-foreground hover:bg-muted'}`
                }>

                  <Icon data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:838:18" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="838" data-component-end-line="838" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={option.icon as any} size={18} />
                  <span data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:839:18" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="839" data-component-end-line="839" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-sm%22%7D" className="text-sm">{option.label}</span>
                </button>
              )}
            </div>
          </div>

          {/* Results Count */}
          <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:846:10" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="846" data-component-end-line="850" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-4%20text-center%22%7D" className="mt-4 text-center">
            <p data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:847:12" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="847" data-component-end-line="849" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%2C%22textContent%22%3A%22Showing%20categories%22%7D" className="text-sm text-muted-foreground">
              Showing <span data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:848:22" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="848" data-component-end-line="848" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-semibold%20text-foreground%22%7D" className="font-semibold text-foreground">{filteredCategories.length}</span> categories
            </p>
          </div>
        </div>
      </section>

      {/* Categories Grid */}
      <section data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:855:6" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="855" data-component-end-line="876" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%22%7D" className="py-16">
        <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:856:8" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="856" data-component-end-line="875" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%22%7D" className="container mx-auto px-4">
          <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:857:10" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="857" data-component-end-line="866" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-16%22%7D" className="space-y-16">
            <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:858:12" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="858" data-component-end-line="865" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-16%22%7D" className="space-y-16">
              {filteredCategories.map((category) =>
              <ServiceCategoryCard data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:860:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="860" data-component-end-line="862" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="ServiceCategoryCard" data-component-content="%7B%22elementName%22%3A%22ServiceCategoryCard%22%7D"
                key={category.id}
                category={category} />

              )}
            </div>
          </div>

          {filteredCategories.length === 0 &&
          <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:869:10" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="869" data-component-end-line="873" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20py-16%22%7D" className="text-center py-16">
              <Icon data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:870:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="870" data-component-end-line="870" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22MagnifyingGlassIcon%22%2C%22className%22%3A%22mx-auto%20text-muted-foreground%20mb-4%22%7D" name="MagnifyingGlassIcon" size={64} className="mx-auto text-muted-foreground mb-4" />
              <h3 data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:871:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="871" data-component-end-line="871" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-2xl%20font-headline%20font-bold%20text-foreground%20mb-2%22%2C%22textContent%22%3A%22No%20results%20found%22%7D" className="text-2xl font-headline font-bold text-foreground mb-2">No results found</h3>
              <p data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:872:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="872" data-component-end-line="872" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%22%2C%22textContent%22%3A%22Try%20adjusting%20your%20search%20or%20filter%20criteria%22%7D" className="text-muted-foreground">Try adjusting your search or filter criteria</p>
            </div>
          }
        </div>
      </section>

      {/* Trust Section */}
      <section data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:879:6" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="879" data-component-end-line="907" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20bg-card%2F30%22%7D" className="py-16 bg-card/30">
        <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:880:8" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="880" data-component-end-line="906" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%22%7D" className="container mx-auto px-4">
          <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:881:10" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="881" data-component-end-line="905" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-4xl%20mx-auto%20text-center%20space-y-8%22%7D" className="max-w-4xl mx-auto text-center space-y-8">
            <h2 data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:882:12" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="882" data-component-end-line="884" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20sm%3Atext-4xl%20font-headline%20font-bold%20text-foreground%22%2C%22textContent%22%3A%22Verified%20%26%20Licensed%20Services%22%7D" className="text-3xl sm:text-4xl font-headline font-bold text-foreground">
              Verified & Licensed Services
            </h2>
            <p data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:885:12" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="885" data-component-end-line="887" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20text-muted-foreground%22%2C%22textContent%22%3A%22All%20services%20feature%20verified%20licenses%2C%20compliance%20badges%2C%20and%20authenticity%20certificates%20with%20direct%20verification%20links%22%7D" className="text-lg text-muted-foreground">
              All services feature verified licenses, compliance badges, and authenticity certificates with direct verification links
            </p>
            <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:888:12" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="888" data-component-end-line="904" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20md%3Agrid-cols-3%20gap-6%22%7D" className="grid md:grid-cols-3 gap-6">
              <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:889:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="889" data-component-end-line="893" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20p-6%20rounded-xl%20cosmic-border%22%7D" className="bg-card p-6 rounded-xl cosmic-border">
                <Icon data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:890:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="890" data-component-end-line="890" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ShieldCheckIcon%22%2C%22className%22%3A%22mx-auto%20text-secondary%20mb-4%22%7D" name="ShieldCheckIcon" size={40} className="mx-auto text-secondary mb-4" />
                <h3 data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:891:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="891" data-component-end-line="891" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-semibold%20text-foreground%20mb-2%22%2C%22textContent%22%3A%22Verified%20Licenses%22%7D" className="text-lg font-semibold text-foreground mb-2">Verified Licenses</h3>
                <p data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:892:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="892" data-component-end-line="892" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%2C%22textContent%22%3A%22All%20services%20include%20authentic%20license%20numbers%22%7D" className="text-sm text-muted-foreground">All services include authentic license numbers</p>
              </div>
              <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:894:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="894" data-component-end-line="898" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20p-6%20rounded-xl%20cosmic-border%22%7D" className="bg-card p-6 rounded-xl cosmic-border">
                <Icon data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:895:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="895" data-component-end-line="895" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22CheckBadgeIcon%22%2C%22className%22%3A%22mx-auto%20text-secondary%20mb-4%22%7D" name="CheckBadgeIcon" size={40} className="mx-auto text-secondary mb-4" />
                <h3 data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:896:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="896" data-component-end-line="896" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-semibold%20text-foreground%20mb-2%22%2C%22textContent%22%3A%22Instant%20Access%22%7D" className="text-lg font-semibold text-foreground mb-2">Instant Access</h3>
                <p data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:897:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="897" data-component-end-line="897" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%2C%22textContent%22%3A%22Subscribe%20and%20get%20immediate%20service%20access%22%7D" className="text-sm text-muted-foreground">Subscribe and get immediate service access</p>
              </div>
              <div data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:899:14" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="899" data-component-end-line="903" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20p-6%20rounded-xl%20cosmic-border%22%7D" className="bg-card p-6 rounded-xl cosmic-border">
                <Icon data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:900:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="900" data-component-end-line="900" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22BoltIcon%22%2C%22className%22%3A%22mx-auto%20text-secondary%20mb-4%22%7D" name="BoltIcon" size={40} className="mx-auto text-secondary mb-4" />
                <h3 data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:901:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="901" data-component-end-line="901" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-semibold%20text-foreground%20mb-2%22%2C%22textContent%22%3A%2224%2F7%20Support%22%7D" className="text-lg font-semibold text-foreground mb-2">24/7 Support</h3>
                <p data-component-id="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx:902:16" data-component-path="src/app/ai-service-categories-hub/components/AIServiceCategoriesInteractive.tsx" data-component-line="902" data-component-end-line="902" data-component-file="AIServiceCategoriesInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%2C%22textContent%22%3A%22Round-the-clock%20assistance%20for%20all%20services%22%7D" className="text-sm text-muted-foreground">Round-the-clock assistance for all services</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>);

};

export default AIServiceCategoriesInteractive;